<template>
    <div class="context common_table_view">
        <div class="header" ref="header">
            <div class="search">
                <div class="search_item">
                    <div class="title"></div>
                    <div class="input_box">
                        <el-input v-model="searchForm.input"
                                  placeholder="请输入姓名或手机号"
                                  class="width_400"
                                  @change="getTableData()"
                                  size="small"
                                  clearable></el-input>
                        <span style="padding-left: 10px">
                        <el-button type="primary"
                                   size="small"
                                   @click="getTableData()">搜索</el-button>
                    </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="table">
            <el-table :data="tableData"
                      stripe
                      width="100%"
                      height="100%">
                <el-table-column v-for="(item, index) in columnData"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :width="item.width"
                                 :formatter="item.formatter"
                                 :fixed="item.fixed"
                                 show-overflow-tooltip
                                 :key="index"></el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.open_status == 2"
                                   size="mini"
                                   @click="submitStatus(scope.row, 1)"
                                   type="danger">拒绝</el-button>
                        <el-button v-if="scope.row.open_status == 2"
                                   size="mini"
                                   @click="submitStatus(scope.row, 3)"
                                   type="primary">通过</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="bottom_page">
            <page-view @getTableList="handleCurrentChange"
                       :currentPage="currentPage"
                       :pageSize="pageSize"
                       :total="total"></page-view>
        </div>
    </div>
</template>

<script>
    import {mapMutations, mapState} from "vuex";
    import {clone} from "../../global/utils";

    export default {
        name: "tableView",
        data() {
            const showStatus = (row, column, cellValue, index) => {
                return cellValue=='1'?'已拒绝':
                    cellValue=='2'?'待审核':
                        cellValue=='3'?'已通过':
                            '未知'
            };
            const showRepJob = (row, column, cellValue, index) => {
                let job_list = row.rep_detail.job_list;
                let text = job_list[0] ? job_list[0].department_name : '';
                // job_list.forEach(v => {
                //     text = v.department_name
                // });
                return text
            };
            const showRepJob2 = (row, column, cellValue, index) => {
                let job_list = row.rep_detail.job_list;
                let text = job_list[0] ? job_list[0].job : '';
                return text
            };
            return {
                currentPage: 1,
                pageSize: 50,
                total: 0,

                searchForm: {
                    input: '',
                },


                tableData: [],
                columnData: [
                    {label: '申请人', prop: 'rep_detail.name'},
                    {label: '部门', prop: 'rep_detail', formatter: showRepJob, width: 500},
                    {label: '岗位', prop: 'rep_detail', formatter: showRepJob2, width: 160},
                    {label: '拜访对象', prop: 'patient_name'},
                    {label: '医院', prop: 'hospital'},
                    {label: 'HCP', prop: 'doctor_name'},
                    {label: '科室', prop: 'department'},
                    {label: '病种', prop: 'tumour'},
                    {label: '状态', prop: 'open_status', formatter: showStatus},
                ]
            }
        },
        mounted() {
            this.getTableData()
        },
        beforeDestroy() {
        },
        methods: {
            ...mapMutations('illuserData', {
            }),
            submitStatus(row, val) {
                console.log(row, '122');
                let params = {
                    patient_id: row.patient_id,
                    open_status: val, // 1拒绝 3 同意
                };
                let text = val == 1? '拒绝成功': val == 3? '审核通过': '';
                    this.httpPost('/user/patient_limited_status', params).then(res => {
                    if(res.code == 0) {
                        this.$message.success(text);
                        this.getTableData(this.currentPage)
                    }
                })
            },

            handleCurrentChange(val) {
                this.getTableData(val)
            },
            getTableData(v = 1) {
                let params = {
                    page: v,
                    page_size: this.pageSize,
                    input: this.searchForm.input,
                };
                let config = {
                    timeout: 0
                };
                // console.log(params, '69');
                this.httpGet('/user/patient_limited_list', params, config).then(res => {
                    this.tableData = res.data.data_list;
                    this.total = res.data.total;
                    this.$nextTick(() => {
                        this.currentPage = v
                    })
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>